import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { FormService } from 'src/app/services/core/form.service';

@Component({
  selector: 'ta-basic-input',
  templateUrl: './basic-input.component.html',
  styleUrls: ['./basic-input.component.css'],
})
export class BasicInputComponent implements OnInit {
  @Input() set formControlFunc(formControl: FormControl) {
    this.formControl = formControl;
  }
  formControl: FormControl;

  @Input() inputLabel: string;
  @Input() inputType: string;
  @Input() hint: string;
  @Input() isDisable: boolean = false;
  @Input() isSubmit: boolean = false;
  @Input() isShowError: boolean = false;
  @Input() textMask: [];
  constructor(public formService: FormService) {}
  goster() {
    console.log(this.formControl);
    console.log(this.isShowError);
  }
  ngOnInit() {
    // this.formControl.valueChanges
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((data) => {
    //     this.formValue = data;
    //   });
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  // valueChange(e) {
  //   ;
  //   this.formControl.patchValue(e.target.value);
  // }
}
